/*
 * サブシステム名：車両管理
 * 機能名：車両マスタ一覧
 */
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

// import date from '@/ddv2.library/date'
import d2fmt from '@/ddv2.library/utils/formatter'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import VTour from '@/components/DdCoachMark.vue'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdListHeader from '@/components/DdListHeader'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdTextBox from '@/components/DdTextBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import CoachMark from './CoachMark/D2MSTT0195.js'

export default {
  name: 'MstJininListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdIconButtonWithTooltip,
    DdListHeader,
    DdSpreadSheet,
    DdTextBox,
    DdTransparentButton
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    newRowCount: 0,
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      sharyoNo: '',
      jidoshaHyojiNm: '',
      eigyoshoCd: ''
    },

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    modeKengen: 0,
    pageCount: 0,
    // ヘッダー定義
    headersEigyoshoList: header.mstEigyoshoHeaders,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },

    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      return false
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              sharyoNo: '',
              jidoshaHyojiNm: '',
              eigyoshoCd: self.usersEigyoshoCd
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstJininList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstJininList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.searchAction()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstJininList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstJininList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              // self.onNewRowButtonClick()
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.$nextTick(() => {
        this.searchAction()
      })
    },
    searchAction: function (e) {
      this.selected = []
      this.newRowCount = 0
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstSharyo/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload.map((elem) => {
            // 車両番号は文字列変換 先頭ゼロを残すため
            elem.sharyoNo = String(elem.sharyoNo)
            elem.tekiyoStartYmd = filter.dateFormatter(elem.tekiyoStartYmd)
            elem.tekiyoEndYmd = filter.dateFormatter(elem.tekiyoEndYmd)
            elem.nextShakenYmd = [undefined, null, ''].includes(elem.nextShakenYmd) ? null : filter.dateFormatter(elem.nextShakenYmd)
            elem.nextOilYmd = [undefined, null, ''].includes(elem.nextOilYmd) ? null : filter.dateFormatter(elem.nextOilYmd)
            elem.hyojiOrder = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
            return elem
          })

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              sharyoNo: '',
              jidoshaHyojiNm: '',
              eigyoshoCd: self.usersEigyoshoCd
            }
            this.searchText = ''
            this.rows = []
            this.page = 1
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    onMultiSaveButtonClick: function () {
      const self = this
      // 変更フラグONかつキー項目≠Nullのもののみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && !['', null, undefined].includes(elem.sharyoNo) && !['', null, undefined].includes(elem.jidoshaHyojiNm) && !['', null, undefined].includes(elem.hyojiOrder)
      }).map((elem) => {
        // LITE版は営業所コード一つの為ログイン者と同じ営業所コードをセット
        elem.eigyoshoCd = self.usersEigyoshoCd
        return elem
      })
      if (saveTargetRow.length < 1) { return }

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 営業所
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.eigyoshoNm)
      }).map((elem) => {
        const m = self.eigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.eigyoshoNm
        })
        if (m.length > 0) {
          elem.eigyoshoCd = m[0].eigyoshoCd
        }
        return elem
      })

      // 主な乗務員
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.jomuinNm)
      }).map((elem) => {
        const m = self.jininList.filter(function (item) {
          return item.jininNmSei === elem.jomuinNm
        })
        if (m.length > 0) {
          elem.jomuinCd = m[0].jininCd
        }
        return elem
      })

      // 数値変換
      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? -1 : elem.id
        elem.hyojiOrder = d2fmt.removeComma(elem.hyojiOrder)
        return elem
      })
      this.$nextTick(function () {
        self.saveAction(saveTargetRow)
      })
    },
    saveAction: function (data) {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.registerPromise(data)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.selected = []
            const dataList = data.payload
            dataList.map((elem) => {
              elem.editFlg = false
              elem.editMode = false
              elem.memo = ''

              elem.sharyoNo = String(elem.sharyoNo)
              elem.tekiyoStartYmd = filter.dateFormatter(elem.tekiyoStartYmd)
              elem.tekiyoEndYmd = filter.dateFormatter(elem.tekiyoEndYmd)
            })

            dataList.forEach(elem => {
              const tagetRow = self.rows.find(n => n.sharyoNo === elem.sharyoNo)
              if (tagetRow) {
                const index = this.rows.indexOf(tagetRow)
                // 取得データを差し替え
                Object.assign(this.rows[index], elem)
              }
            })

            self.rows.splice()
            self.Effects.loadComplete()

            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        },
        validateNotificationModeMethod: function () {
          return true
        },
        validateNotificationMethod: function () {
          const errList = self.$refs.ddSpreadSheet.errorList
          console.log('validateNotificationMethod', errList)
          if (errList.length > 0) {
            let errorMessages = ''
            errList.forEach(e => {
              let message = '<br>'
              message += `${e.y + 1}行目：${e.msg}`
              errorMessages += message
            })
            modals.showError(`入力内容に誤りがあります。${errorMessages}`)
          } else {
            modals.showToastMessage('COME0001', null, 600, null, null)
          }
        }
      }
      this.register(opt)
    },
    // 登録処理
    registerPromise: function (data) {
      console.log(' > registerPromise', data)
      this.Effects.loadStart()
      const l = this.HttpClient.put('/api/v1/mstSharyo/BatchRegister', data)

      return l
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 営業所
        var wkEigyoshoList = []
        const mEigyoshoList = this.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tEigyoshoList = mEigyoshoList.map(elem => {
          return elem.eigyoshoNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 人員
        var wkJininList = []
        const mJininList = this.jininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tJininList = mJininList.map(elem => {
          return elem.jininNmSei
        })
        wkJininList = wkJininList.concat(tJininList)

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        self.headers = [
          // ----------
          {
            title: '車両番号',
            name: 'sharyoNo',
            type: 'text',
            validateType: 'Free',
            validateLength: 8,
            customInput: null,
            required: true,
            readOnly: false,
            width: '120px',
            parseValue: function (value) {
              // 入力値を常に文字列として扱う
              return String(value)
            }
          },
          { title: '表示名', name: 'jidoshaHyojiNm', type: 'text', validateType: 'Free', validateLength: 50, customInput: null, required: true, readOnly: false, width: '200px' },
          { title: '営業所', name: 'eigyoshoNm', type: 'dropdown', source: wkEigyoshoList, required: true, readOnly: false, width: '150px', autocomplete: true },
          { title: '主な乗務員', name: 'jomuinNm', type: 'dropdown', source: wkJininList, required: false, readOnly: false, width: '200px', autocomplete: true },
          { title: '次回車検日', name: 'nextShakenYmd', type: 'customDate', validateType: 'Date', required: false, readOnly: false, width: '120px' },
          { title: '次回オイル交換日', name: 'nextOilYmd', type: 'customDate', validateType: 'Date', required: false, readOnly: false, width: '120px' },
          { title: '表示順', name: 'hyojiOrder', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, readOnly: false, align: 'right', width: '100px' }
        ]
      })
    },
    rowAppend: function (num) {
      for (let i = 0; i < num; i++) {
        this.newRowCount = this.newRowCount - 1

        const newrow = {
          editFlg: false,
          memo: '',

          id: this.newRowCount,
          sharyoNo: null,
          jidoshaHyojiNm: null,
          eigyoshoNm: null,
          nextShakenYmd: null,
          nexttOilYmd: null,
          fuelKbn: '03',
          workDay: '25',
          tekiyoStartYmd: '2000/01/01',
          tekiyoEndYmd: '2999/12/31',
          hyojiOrder: '9,999'
        }
        this.rows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },

    changeAfter: function (rowData, cell, x, y, newValue, oldValue) {
      console.log('ChangeAfter:', this.rows, rowData, cell, x, y, newValue, oldValue)
      if (newValue === oldValue) return

      if ([undefined, null].includes(rowData.id)) {
        this.newRowCount = this.newRowCount - 1
        const newrow = {
          editFlg: true,

          id: this.newRowCount,
          sharyoNo: newValue,
          jidoshaHyojiNm: null,
          eigyoshoNm: null,
          jomuinNm: null,
          nextShakenYmd: null,
          nexttOilYmd: null,
          fuelKbn: '03',
          workDay: '25',
          tekiyoStartYmd: '2000/01/01',
          tekiyoEndYmd: '2999/12/31',
          hyojiOrder: '9,999'
        }
        this.rows.push(newrow)

        return
      }

      const recIndex = this.rows.findIndex(x => x.id === rowData.id)
      if (recIndex === -1) return

      const rec = this.rows[recIndex]
      rec.editFlg = true

      const keyMap = {
        0: 'sharyoNo',
        1: 'jidoshaHyojiNm',
        2: 'eigyoshoNm',
        3: 'jomuinNm',
        4: 'nextShakenYmd',
        5: 'nextOilYmd',
        6: 'hyojiOrder'
      }

      const key = keyMap[x]
      if (key) {
        rec[key] = newValue
      }
    },

    onNewRowButtonClick: function (e) {
      this.rowAppend(1)
    },

    onDummyFunction: function () {
      return null
    }
  }
}
